import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Span = styled.span`
	color: var(--shade-shade-60, #727780);
	font-family: Public Sans;
	font-size: 14px;
	font-style: normal;
	font-weight: 500;
	line-height: 24px; /* 171.429% */
	margin-left: 15px;
`

class InputBook extends React.Component {
	static propTypes = {
		width: PropTypes.string.isRequired,
		placeholder: PropTypes.string.isRequired,
		spanText: PropTypes.string,
		handleGeneralChange: PropTypes.func,
		titulo: PropTypes.string,
		field: PropTypes.string,
	};

	render() {
		const {
			width,
			placeholder,
			spanText,
			handleGeneralChange,
			titulo,
			field
		} = this.props;

		return (
			<div>
				<Span>{spanText}</Span>
				<input
					style={{ width: `${width}` }}
					type="text"
					className="form-control"
					placeholder={placeholder}
					onChange={(((e) => handleGeneralChange(field, e.target.value)))}
					value={titulo}
				/>
			</div>
		);
	}
}

export default InputBook;
